import React from 'react';
import { Section } from './ui/Section';
import { XCircle } from 'lucide-react';
export function WhyFailSection() {
  return <Section background="white" data-id="element-197">
      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-198">
        <div data-id="element-199">
          <h2 className="text-3xl font-serif font-bold text-warm-dark mb-6" data-id="element-200">
            Por qué lo que probaste antes no funcionó
          </h2>
          <p className="text-lg text-warm-gray mb-6" data-id="element-201">
            La mayoría de "soluciones" atacan el síntoma (peso) con herramientas
            que rompen a una mujer cansada.
          </p>
          <p className="text-lg text-warm-gray" data-id="element-202">
            Esto no es porque seas floja. Es porque esos métodos dependen de una
            cosa que no te sobra:{' '}
            <span className="font-bold text-terracotta" data-id="element-203">batería mental</span>.
          </p>
        </div>

        <div className="bg-cream-dark/30 p-8 rounded-2xl" data-id="element-204">
          <ul className="space-y-6" data-id="element-205">
            <FailItem title="Contar calorías" desc="Funciona hasta que te quedas sin energía mental y te rindes." data-id="element-206" />
            <FailItem title="Eliminar alimentos" desc="Funciona hasta que vuelves a ser humana y quieres vivir." data-id="element-207" />
            <FailItem title="Cardio castigo" desc="Funciona hasta que te da más hambre y menos paciencia." data-id="element-208" />
          </ul>
        </div>
      </div>
    </Section>;
}
function FailItem({
  title,
  desc
}: {
  title: string;
  desc: string;
}) {
  return <li className="flex items-start" data-id="element-209">
      <XCircle className="w-6 h-6 text-terracotta mt-1 mr-4 flex-shrink-0" data-id="element-210" />
      <div data-id="element-211">
        <h4 className="font-bold text-warm-dark text-lg" data-id="element-212">{title}</h4>
        <p className="text-warm-gray" data-id="element-213">{desc}</p>
      </div>
    </li>;
}